import { render, staticRenderFns } from "./RelatorioRetornouOrigemListFiltro.vue?vue&type=template&id=37914d13"
import script from "./RelatorioRetornouOrigemListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioRetornouOrigemListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports